import { render, staticRenderFns } from "./DebitCard.vue?vue&type=template&id=048d85c4&"
import script from "./DebitCard.vue?vue&type=script&lang=js&"
export * from "./DebitCard.vue?vue&type=script&lang=js&"
import style0 from "./DebitCard.vue?vue&type=style&index=0&id=048d85c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports